import { FindClassificationsFilterOptionsOutput } from '../../../services/modules/filterOptions/filterOptions.types';
import {
  Classification,
  ClassificationTypeOriginEnum,
} from '../../classifications/classification.types';
import { ColorClassification } from '../../products/product.types.v2';
import { OfflineDatabaseClassification } from '../database/offlineDatabase/types/offlineDatabaseClassification.types';

export class OfflineClassificationTransformers {
  static toFilterOptionsClassification(
    data: OfflineDatabaseClassification,
  ): FindClassificationsFilterOptionsOutput['data'][0] {
    return {
      id: data.id,
      code: data.code,
      name: data.name,
      typeName: '',
      typeOrigin: ClassificationTypeOriginEnum.TECEO,
    };
  }

  static toProductSearchSuggestedClassifications(
    data: OfflineDatabaseClassification,
  ): Classification {
    return {
      id: data.id,
      code: data.code,
      name: data.name,
      classificationType: {} as Classification['classificationType'],
    };
  }

  static toColorClassification(data: OfflineDatabaseClassification): ColorClassification {
    return {
      id: data.id,
      code: data.code,
      name: data.name,
      classificationType: {
        id: data.classificationTypeId,
      } as Classification['classificationType'],
    };
  }
}
